import { WaveformIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import React from 'react';
import { Color } from 'utils/color';
import style from './PromptCard.scss';

export const PromptCard = ({ title, description, clickHandler }) => {
  return (
    <div className={style.promptContainer} onClick={clickHandler}>
      <div className={style.iconContainer}>
        <WaveformIcon color={Color.GRAY_BLUE} />
      </div>

      <div className={style.textContainer}>
        <Text className={style.promptTitle}>{title}</Text>
        <Text className={style.promptSummary}>{description}</Text>
      </div>
    </div>
  );
};
